import { Card, CardContent, Link, Typography } from '@mui/material';
import React, { FunctionComponent } from 'react';

interface LydiaPaymentCardProps {
  lydiaLink: string;
}

export const LydiaPaymentCard: FunctionComponent<LydiaPaymentCardProps> = ({
  lydiaLink,
}) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h6">{'Lydia'}</Typography>
        <Typography variant="body1">
          {'Voici le lien de la cagnotte lydia :'}
        </Typography>
        <Link variant="body2" href={lydiaLink}>
          {lydiaLink}
        </Link>
        <Typography variant="body1">
          {
            "N'oubliez pas de préciser votre nom et prénom dans le libellé du virement. Si vous payez pour plusieurs personnes, merci de préciser le nom et prénom de chaque personne, ou contactez l'organisation"
          }
        </Typography>
      </CardContent>
    </Card>
  );
};
